module.exports = __webpack_public_path__ + "static/media/29COICT7.0d1222e9.jpg";